import { State } from '../../types';

export const newJersey: State = {
  name: 'New Jersey',
  abbreviation: 'NJ',
  terms: [
    {
      word: 'Absecon',
      phonetic: 'ab-SEE-con',
      // audioUrl: '/audio/absecon.mp3',
      description: 'A city in Atlantic County, often mispronounced due to its unique spelling.'
    },
    {
      word: 'Allamuchy',
      phonetic: 'al-uh-MOO-chee',
      // audioUrl: '/audio/allamuchy.mp3',
      description: 'A township in Warren County, derived from a Native American term meaning "place in the hills."'
    },
    {
      word: 'Bernards Township',
      phonetic: 'BER-nards',
      // audioUrl: '/audio/bernards_township.mp3',
      description: 'A township in Somerset County, often mispronounced as "ber-NARDS."'
    },
    {
      word: 'Bernardsville',
      phonetic: 'BER-nards-vil',
      // audioUrl: '/audio/bernardsville.mp3',
      description: 'A borough in Somerset County, pronounced with the emphasis on the first syllable.'
    },
    {
      word: 'Buena',
      phonetic: 'BYOO-nuh',
      // audioUrl: '/audio/buena.mp3',
      description: 'A borough in Atlantic County, pronounced differently from the Spanish word for "good."'
    },
    {
      word: 'Forked River',
      phonetic: 'FOR-ked RIV-er',
      // audioUrl: '/audio/forked_river.mp3',
      description: 'A community in Lacey Township, Ocean County, with a two-syllable pronunciation for "Forked."'
    },
    {
      word: 'Gloucester',
      phonetic: 'GLAW-ster',
      // audioUrl: '/audio/gloucester.mp3',
      description: 'A county and city in New Jersey, pronounced with a silent "c."'
    },
    {
      word: 'Ho-Ho-Kus',
      phonetic: 'HO-ho-kus',
      audioUrl: '/audio/hohokus.mp3',
      description: 'Borough in Bergen County'
    },
    {
      word: 'Kearny',
      phonetic: 'CAR-nee',
      // audioUrl: '/audio/kearny.mp3',
      description: 'A town in Hudson County, often mispronounced due to its spelling.'
    },
    {
      word: 'Mantoloking',
      phonetic: 'man-tuh-LOH-king',
      // audioUrl: '/audio/mantoloking.mp3',
      description: 'A borough in Ocean County, with a name of Native American origin.'
    },
    {
      word: 'Maurice River',
      phonetic: 'MOR-iss RIV-er',
      // audioUrl: '/audio/maurice_river.mp3',
      description: 'A river in southern New Jersey, with "Maurice" pronounced as "Morris."'
    },
    {
      word: 'Metuchen',
      phonetic: 'meh-TUCH-en',
      // audioUrl: '/audio/metuchen.mp3',
      description: 'A borough in Middlesex County, often mispronounced by non-locals.'
    },
    {
      word: 'Pequannock',
      phonetic: 'peh-KWAN-ick',
      // audioUrl: '/audio/pequannock.mp3',
      description: 'A township in Morris County, derived from a Native American word.'
    },
    {
      word: 'Secaucus',
      phonetic: 'SEE-kaw-cus',
      // audioUrl: '/audio/secaucus.mp3',
      description: 'A town in Hudson County, pronounced with the emphasis on the first syllable.'
    }
  ]
};